import menuLinks from "@/data/menu-links.data";

const state = {
  menu: menuLinks,
  homeHeaderYSize: 0,
  showSearch: false,
  showMenu: false,
  activeClass: "normal"
};

const getters = {
  header: (state: {}) => {
    return state;
  }
};

function setMenu(show: boolean, active: string) {
  state.showMenu = show;
  state.activeClass = active;
}

const mutations = {
  resizeMenu(state: any) {
    if (
      document.body.clientWidth > 767 &&
      state.homeHeaderYSize > window.pageYOffset
    ) {
      setMenu(false, "normal");
    }
  },
  handleScroll(state: any) {
    if (
      state.homeHeaderYSize <= Math.ceil(window.pageYOffset) &&
      state.activeClass != "sticky"
    ) {
      state.showSearch = false;
      state.activeClass = "sticky";
    } else if (
      state.homeHeaderYSize > Math.ceil(window.pageYOffset) &&
      state.activeClass != "normal"
    ) {
      setMenu(false, "normal");
    }
  },
  toggleSearch(state: any) {
    state.showSearch = !state.showSearch;
  },
  toggleMenu(state: any) {
    state.showMenu = !state.showMenu;
  },
  closeMenu(state: any) {
    state.showMenu = false;
  }
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions
};
